import { BASE_URL, getAdminToken } from '@/api'

let abortController = null
let reconnectTimer = null
let reconnectMs = 2000
const MAX_RECONNECT_MS = 30000

function consumeSseBuffer(buffer, onRefresh) {
  const parts = buffer.split('\n\n')
  const rest = parts.pop() || ''
  for (const block of parts) {
    if (!block.trim()) continue
    let eventName = 'message'
    let data = ''
    for (const line of block.split('\n')) {
      if (line.startsWith('event:')) eventName = line.slice(6).trim()
      else if (line.startsWith('data:')) data += line.slice(5).trim()
      else if (line.startsWith(':')) {
        /* heartbeat / comment */
      }
    }
    if (eventName === 'refresh' && typeof onRefresh === 'function') {
      onRefresh(data)
    }
  }
  return rest
}

async function readSseStream(body, onRefresh) {
  const reader = body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  let chunk = await reader.read()
  while (!chunk.done) {
    buffer += decoder.decode(chunk.value, { stream: true })
    buffer = consumeSseBuffer(buffer, onRefresh)
    chunk = await reader.read()
  }
  throw new Error('stream ended')
}

function scheduleReconnect(onRefresh) {
  if (reconnectTimer) return
  reconnectTimer = window.setTimeout(() => {
    reconnectTimer = null
    connectAdminNotificationStream(onRefresh)
    reconnectMs = Math.min(reconnectMs * 2, MAX_RECONNECT_MS)
  }, reconnectMs)
}

/** 建立 SSE 长连接；收到 refresh 事件时回调 onRefresh。 */
export function connectAdminNotificationStream(onRefresh) {
  disconnectAdminNotificationStream()
  const token = getAdminToken()
  if (!token) return

  abortController = new AbortController()
  const base = String(BASE_URL || '').replace(/\/$/, '')
  const url = `${base}/api/admin/notifications/stream`

  void (async () => {
    try {
      const resp = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'text/event-stream',
        },
        signal: abortController.signal,
      })
      if (!resp.ok || !resp.body) {
        throw new Error(`stream ${resp.status}`)
      }
      reconnectMs = 2000
      await readSseStream(resp.body, onRefresh)
      throw new Error('stream closed')
    } catch (e) {
      if (abortController?.signal.aborted) return
      scheduleReconnect(onRefresh)
    }
  })()
}

export function disconnectAdminNotificationStream() {
  if (reconnectTimer) {
    window.clearTimeout(reconnectTimer)
    reconnectTimer = null
  }
  reconnectMs = 2000
  if (abortController) {
    abortController.abort()
    abortController = null
  }
}
